import tabs from '../data/tabs';
import { getUrlKey } from "@/util/util";

export default {
    data() {
        return {
            params: {},
            star: {
                article: [],
                topic: [],
                activity: []
            },
            info: {},
            link_data: {},
            tabs,
            selected: 0,
            count: 0,
            p: 1
        }
    },

    watch:{
        '$route':'getId'
    },

    created() {

        this.params = {
            id: getUrlKey('id',location.href),
            name: getUrlKey('name',location.href)
        };

        document.title = this.params.name + '- 明星头条';
        this.getStarInfo();
        this.getRightInfo();
    },

    methods: {

        openIndex() {
            this.$router.push({
                name: 'star'
            })
        },

        getId() {
            // this.params = this.$route.query.data || {};
            this.params = {
                id: getUrlKey('id',location.href),
                name: getUrlKey('name',location.href)
            };
            this.getStarInfo()
        },

        changePage(e) {
            this.p = e;
            this.getStarInfo();
        },

        changeTab(item,index) {
            this.p = 1;
            this.selected = index;
            if(index === 2) {
                let arr = this.star.activity.list || [];
                arr.map(item => {
                    item.time_start = item.time_start.replace('-','.');
                    item.time_end = item.time_end.replace('-','.');
                })
                this.star.activity.list = arr;
            }
            this.count = this.star[item.key].count || 0;

        },

        getStarInfo() {
            const loading = this.$loading({
                message: '加载中...'
            })
            this.$post('api.php/Home/starHome',{
                star_id: this.params.id || '',
                p: this.p
            }).then(res => {
                if(res.status == 1) {
                    this.star = res.data || {};
                }
            }).finally(()=>{
                loading.close();
            })
        },

        getRightInfo() {
            this.$post('api.php/Home/starHomeRight').then(res => {
                if(res.status == 1) {
                    this.info = res.data || {};
                }
            })
        }
    }
}
